export const relationOption = {
    addBtn: false,
    menu: false,
    refreshBtn: false,
    columnBtn: false,
    menuBtn: false,
    column: [{
        prop: 'name',
        label: '姓名',
        width: 100,
    }, {
        prop: 'cardId',
        label: '身份证编号',
        width: 180,
    }, 
    {
        label: '职业',
        prop: 'occupation',
    },
    {
        prop: 'phone',
        label: '联系方式',
    }, {
        prop: 'relation',
        label: '关系',
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'interpersonal_relationship'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    }, {
        width: 60,
        prop: 'age',
        label: '年龄',
    }, {
        label: '说明',
        prop: 'remarks',
        type: 'textarea',
    }]
}

export const initOption = {
    addBtn: false,
    menu: false,
    refreshBtn: false,
    columnBtn: false,
    menuBtn: false,
    column: [{
        width: 110,
        label: '计划单序号',
        prop: 'orderInitNumber'
    }, {
        label: "机构",
        prop: 'initPlanCreateDeptName',
    }, {
        label: "类型",
        prop: 'type',
        type: "select",
        dataType: 'string',
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'work_type'
        },
        formatter: (row, value, label, column) => {
            return label
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        }
    }, {
        label: '建议转派机构',
        prop: 'description'
    }, {
        label: '内容',
        prop: 'content'
    }, {
        label: '优先级',
        prop: 'priority',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'priority'
        },
        formatter: (row, value, label, column) => {
            return label
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        }
    }, {
        label: '范围',
        prop: 'planScope',
        type: "select",
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'range_type'
        },

        props: {
            label: "dictValue",
            value: "dictKey"
        }
    }, {
        label: '开始时间',
        prop: 'beginTime',
        type: 'date',
        format: 'yyyy-MM-dd'
    }, {
        label: '完成时间',
        prop: 'endTime',
        type: 'date',
        format: 'yyyy-MM-dd'
    }]
}

export const kinshipOption = {
    addBtn: false,
    menu: false,
    refreshBtn: false,
    columnBtn: false,
    menuBtn: false,
    column: [{
        label: '姓名',
        prop: 'name',
        width: 100,
    }, {
        label: '身份证编号',
        prop: 'cardId',
        width: 180,
    }, {
        label: '职业',
        prop: 'occupation',
    },{
        label: '年龄',
        prop: 'age',
    }, {
        label: '文化程度',
        prop: 'standard',
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'education_degree'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    }, {
        label: '关系',
        prop: 'relation',
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'relationship'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
    }, {
        label: '联系方式',
        prop: 'phone'
    }, {
        label: '收入',
        prop: 'income'
    }]
}

export const recordOption = {
    addBtn: false,
    menu: false,
    refreshBtn: false,
    columnBtn: false,
    menuBtn: false,
    column: [{
        label: '走访类型',
        prop: 'interviewType',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary",
        dicQuery: {
            code: 'visit-tracking_method'
        },
        props: {
            label: "dictValue",
            value: "dictKey"
        },
        formatter:(row, value, label, column) => {
            return label
        }
    }, {
        label: '内容',
        prop: 'content'
    }, {
        label: '时间',
        prop: 'visitTime',
        width: 160,
    }, {
        label: '走访机构',
        prop: 'createDeptName'
    }, {
        label: '记录人',
        prop: 'createUserName'
    }]
}


export const judicialOption = {
    addBtn: false,
    menu: false,
    refreshBtn: false,
    columnBtn: false,
    // showHeader: false,
    menuBtn: false,
    column: [{
            label: '凭证编号',
            prop: 'voucherNo',
        }, {
            label: '颁发机构',
            prop: 'awardOrg',
            dataType: 'string',
            // type: 'select',
            // type: 'cascader',
            type: 'tree',
            multiple: true,
            checkStrictly: true,
            // emitPath: false,
            leafOnly: false,
            // dicUrl: "/api/blade-order/order/getDeptList",
            dicUrl: "/api/blade-system/dept/tree",
            props: {
                // label: "deptName",
                // value: "id"
                label: 'title'
            },
            formatter: (row, value, label, column) => {
                return label
            },
        },
        {
            label: '凭证类型',
            prop: 'type',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'document_type'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
        },
        {
            label: '颁发时间',
            prop: 'awardTime',
            type: 'date',
            valueFormat: "yyyy-MM-dd hh:mm:ss",
        }, {
            label: '代理人姓名',
            prop: 'agent',
        },
        {
            label: '身份证',
            prop: 'cardId',
        }
    ]
}
